// @flow

/**
 * AI Reports Chat Constants
 * AI Reports-specific configuration values
 */

export const TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes
